import { webpUrl, mobileUrl } from "@/lib/images";

/** Objektbild mit WebP-Variante (<picture>), wenn das Objekt webp_ready ist – sonst normales <img>. Mit mobile (mobile_ready) bekommen Handys die 720-px-Variante. */
export const Pic = ({ src, webp, mobile = false, ...props }) => {
  const w = webp ? webpUrl(src) : "";
  if (!w) return <img src={src} {...props} />;
  const m = mobile ? mobileUrl(src) : "";
  return (
    <picture className="contents">
      {m && <source media="(max-width: 767px)" type="image/webp" srcSet={m} />}
      <source type="image/webp" srcSet={w} />
      <img src={src} {...props} />
    </picture>
  );
};
